import { FC, useEffect, useState } from 'react'
import { RenderIf } from 'components/RenderIf'
import { Button } from 'featureSliced/entities/Button'
import { Radio, RadioContainer } from 'components/Radio/styled'
import { CheckBox } from 'featureSliced/entities/CheckBox'
import { ITableCloudItem } from 'featureSliced/shared/store/reducers/QRMenuTableReducer/types'
import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { usePayment } from 'featureSliced/shared/hooks/usePayment'
import { CCProvider } from 'featureSliced/shared/utils/getCCProviderIcon'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

type CardsModalProps = {
  itemsToPay: ITableCloudItem[] | IBucketProduct[]
  isLoyaltyCardExisting: boolean
  isLoyaltyCardDisabled: boolean
  tipsValue: number
  userCardData: any
  closeModal: () => void
  total?: number
}

export const CardsModal: FC<CardsModalProps> = ({
  ///
  itemsToPay,
  isLoyaltyCardExisting,
  isLoyaltyCardDisabled,
  tipsValue = 0,
  userCardData,
  closeModal,
  total = 0,
}) => {
  const t = useTranslations()
  const { startQRMAfterMealPayment: paymentRequest } = usePayment()
  const paymentProvider = useMySelector(
    (state) => state.app.paymentConfig?.paymentProviderType
  )

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [value, setValue] = useState<'0' | '1' | '2'>('1')
  const [updateActiveCard, setUpdateActiveCard] = useState(false)

  useEffect(() => {
    if (!userCardData || paymentProvider === 3) {
      setValue('0')
    }
  }, [paymentProvider, userCardData])

  const changeValue = (e: any) => {
    if (e.target.value !== '2') {
      setUpdateActiveCard(false)
    }
    setValue(e.target.value)
  }

  const handlePayClick = async () => {
    setIsLoading(true)
    await paymentRequest(
      itemsToPay,
      // TODO: replace 0 with real value
      total,
      tipsValue,
      value === '1', // useSavedCard
      value === '0', // useCustomerCard
      updateActiveCard && value === '2' // updateActiveCard (if NEW is selected)
    )
    setIsLoading(false)
    closeModal()
  }

  return (
    <div>
      <RenderIf condition={isLoyaltyCardExisting}>
        <RadioContainer isDisabled={isLoyaltyCardDisabled}>
          <Radio
            type="radio"
            id="customer"
            name="customerCard"
            value={0}
            checked={value === '0'}
            onChange={changeValue}
            disabled={isLoyaltyCardDisabled}
          />
          <label htmlFor="customer">
            {isLoyaltyCardDisabled
              ? `${t('order.useCustomerCard')} (${t(
                  'common.insufficientFunds'
                )})`
              : t('order.useCustomerCard')}
          </label>
        </RadioContainer>
      </RenderIf>

      <RenderIf condition={userCardData && paymentProvider !== 3}>
        <RadioContainer>
          <Radio
            type="radio"
            id="saved"
            name="card"
            value={1}
            checked={value === '1'}
            onChange={changeValue}
          />
          <label htmlFor="saved">
            <CCProvider
              cardMask={JSON.parse(userCardData || null)?.masked}
              brandName={JSON.parse(userCardData || null)?.brand?.PaymentMethod}
            />{' '}
            {JSON.parse(userCardData || null)?.masked}
          </label>
        </RadioContainer>
      </RenderIf>

      <RadioContainer>
        <Radio
          type="radio"
          id="useNew"
          name="card"
          value={2}
          checked={value === '2'}
          onChange={changeValue}
        />
        <label htmlFor="useNew">{t('selfService.useNewCard')}</label>
      </RadioContainer>

      <RenderIf condition={value === '2'}>
        <CheckBox
          isChecked={updateActiveCard}
          onClick={setUpdateActiveCard}
          label={t('selfService.newCardAsDefault')}
          isDisabled={value !== '2'}
        />
      </RenderIf>

      <RenderIf condition={value !== '2'}>
        <div style={{ height: '28px' }} />
      </RenderIf>

      <br />

      <Button
        buttonType="common"
        width="100%"
        onClick={handlePayClick}
        isLoading={isLoading}
      >
        {t('cover.pay')}
      </Button>
    </div>
  )
}
